{
  "时段": {
    "清晨": ["晨光正好", "早，今天还很新", "清晨的代码，格外干净", "一日之计", "醒了就好"],
    "上午": ["慢慢来", "上午好", "先喝口水", "日光渐高"],
    "中午": ["午安", "日正当中", "吃饭是正事", "歇一歇再走"],
    "下午": ["午后时光", "下午好", "光影西斜", "一杯茶的工夫"],
    "傍晚": ["暮色四合", "晚风起了", "灯亮了", "归来的人"],
    "夜晚": ["晚上好", "夜读时间", "灯下，慢慢写", "今夜安静"],
    "深夜": ["夜猫子来了", "星光陪你", "夜深了，不急", "月下夜谈", "还醒着的人"]
  },
  "周几": {
    "周一": ["周一快乐"],
    "周二": ["周二，稳稳地"],
    "周三": ["周三，过半了"],
    "周四": ["周四，快到了"],
    "周五": ["周五，将近"],
    "周六": ["周末愉快"],
    "周日": ["周日，慢一点"]
  },
  "初来": ["初次见面", "欢迎，随意坐", "终于等到你"],
  "久别": ["好久不见", "你回来了", "故人归"]
}
